import styled from 'styled-components';

export const Form = styled.form`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.body.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const DateAndTime = styled.div`
  display: flex;
  column-gap: 16px;
  width: 100%;
`;

export const Files = styled.div`
  margin-top: 24px;
  margin-bottom: 32px;

  .filepond--wrapper {
    margin-top: 16px;
    box-sizing: border-box;
  }

  .filepond--root {
    font-family: ${(props) =>
      props.theme.atlas.typography.semantic.body.fontFamily};
    margin-bottom: 0;
    border: 1px dashed ${(props) => props.theme.atlas.core.color.gray[400]};
    border-radius: ${(props) => props.theme.atlas.core.radius.lg};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.default};
    overflow: hidden;
    box-sizing: border-box;
    min-height: 196px;
  }

  .filepond--root .filepond--panel-root {
    border-radius: 0 !important;
  }

  .filepond--root .filepond--drop-label.filepond--drop-label {
    margin: 0;
    padding: 32px 24px 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 196px;
  }

  .filepond--root .filepond--drop-label label {
    display: block;
    width: 100%;
    max-width: 100%;
    cursor: pointer;
  }
`;
